export const WaveValuesPlaceholder = [
  0.019770192401483654, 0.06433722574263812, 0.12644813747145237,
  0.1293571765907109, 0.15656001101247966, 0.15260308326222002,
  0.10042845891788602, 0.12748002119362353, 0.1786990139260888,
  0.14066161524504422, 0.09652095315046609, 0.11245076918974518,
  0.08237155444920063, 0.06032653751783073, 0.11039203316904604,
  0.11282431804575026, 0.09198810425586998, 0.10408694831654429,
  0.1277995184622705, 0.07198200372979045, 0.09023667298257351,
  0.10425299635156988, 0.08571569460444152, 0.09140459502115846,
  0.10597727588377893, 0.11359057046473026, 0.1407196099124849,
  0.17716938148252667, 0.1331676063593477, 0.18228555594570936,
  0.18177245701663197, 0.14313084149733185, 0.14811993655748665,
  0.1436970002669841, 0.09307056340388954, 0.05730334798805416,
  0.08721405263058842, 0.15172747066244482, 0.17809400679543613,
  0.17810575671494008, 0.175188292209059, 0.1148250397387892,
  0.11911557612009346, 0.11376510507427157, 0.08404183183796704,
  0.12065157544799149, 0.12074287467636168, 0.09798793234862387,
  0.1519289273582399, 0.14001987336203456, 0.10006959889084101,
  0.15036389485001564, 0.12173175541684031, 0.08257351174019277,
  0.056372378366068, 0.05822325785644353, 0.09019459452480078,
  0.06969658646732568, 0.0962346878927201, 0.09983626026660204,
  0.14303462202660738, 0.1171490409784019, 0.10387001109309495,
  0.11478005806915462, 0.12413819847628474, 0.0916853965446353,
  0.09372059935703873, 0.09282187703996897, 0.07332969170995057,
  0.138217980414629, 0.1406811562459916, 0.08105229536071419,
  0.17632859020493924, 0.15840397582389415, 0.13192065738141537,
  0.1692320268601179, 0.12563062559813262, 0.10738753938116133,
  0.10811436114832759, 0.11265789687633515, 0.08703776570037007,
  0.07717622542753816, 0.08060057994909585, 0.08273989358916879,
  0.07149434282444417, 0.05781943854875862, 0.08851791135966777,
  0.049281428726390006, 0.02417273768223822, 0.005681236078962684,
]
